type Props = { value: number; size?: "sm" | "md" | "lg"; showNumber?: boolean };

export function RatingStars({ value, size = "md", showNumber = true }: Props) {
  const clamped = Math.max(0, Math.min(5, value));
  const full = Math.floor(clamped);
  const partial = clamped - full;
  const sizeClass = size === "sm" ? "text-sm" : size === "lg" ? "text-2xl" : "text-base";
  return (
    <span className={`inline-flex items-center gap-2 ${sizeClass}`}>
      <span aria-hidden className="text-amber-400">
        {Array.from({ length: 5 }).map((_, i) => {
          const fill = i < full ? 1 : i === full ? partial : 0;
          return (
            <span
              key={i}
              className="relative inline-block"
              style={{ width: "1em", height: "1em" }}
            >
              <span className="absolute inset-0 text-ink-200">★</span>
              <span
                className="absolute inset-0 overflow-hidden text-amber-400"
                style={{ width: `${fill * 100}%` }}
              >
                ★
              </span>
            </span>
          );
        })}
      </span>
      {showNumber && (
        <span className="font-semibold text-ink-800" aria-label={`Rating ${clamped}/5`}>
          {clamped.toFixed(1)}
        </span>
      )}
    </span>
  );
}
